import React from 'react';
import img from '../../media/ai-star-loading.gif';

const AIStarLoading = () => {
  const alt = 'Studio Pro';

  return (
    <img src={img} alt={alt} />
  );
};

export default AIStarLoading;
